export default {
  namespaced: true,
  state: {
    overlay: false,
  },
  getters: {
    overlay: (state) => state.overlay,
  },
  mutations: {
    SHOW_OVERLAY(state) {
      state.overlay = true;
    },
    HIDE_OVERLAY(state) {
      state.overlay = false;
    },
  }
}
